<script>
  let { children, title = null } = $props();
</script>

<div class="wf2-panel">
  {#if title}<h3 class="wf2-panel-title">{title}</h3>{/if}
  {@render children()}
</div>
